import { useContext } from "react";
import { AuthContext } from "../Contexts/Auth";

export function useAuth(){
    const value = useContext(AuthContext)
    return value;
}
